import React, { Component } from 'react';
import "./resume.css";
import CV from "./CV.pdf";


export default class Resume extends Component {
  render() {
    return (
        <div id="resume-wrapper">
            <div id="resume-container">
            <a id="download-button" href={CV} download>
                <button class="btn"><i class="fa fa-download"></i> Download detailed resume </button>
            </a>
            <div id="resume-written">

                <div class="resume-section">
                    <h1>Skills</h1><hr/>
                    <strong class="skill-title">Programming languages:</strong> <div class="skills-listed">C, C#, F#, Java, JavaScript, Python</div><br/><br/>
                    <strong class="skill-title">Web technologies:</strong> <div class="skills-listed">Spring, HTML5, CSS3, React.js, SQL, jQuery</div>

                </div>
                
                <div class="resume-section">
                    <h1>Education</h1><hr/>
                    <strong class="education-title">Bachelor's degree in Computer Science</strong> <div class="place">University of Copenhagen</div><br/> 
                    <div class="date">Sep. 2018 - June 2021(expected)</div><br/><br/>
                    
                    <strong class="education-title">High School</strong> <div class="place">Ordrup Gymnasium</div><br/> 
                    <div class="date">Aug. 2015 - June 2018</div>
                </div>
                

                <div class="resume-section">
                    <h1>Professional experiences</h1><hr/>
                    <strong class="work-title">IT Student</strong> <div class="place">Danske Bank</div><br/> 
                    <div class="date">Mar. 2019 - now</div><br/><br/>

                    <strong class="work-title">Mentor</strong> <div class="place">MentorDanmark</div><br/> 
                    <div class="date">Nov. 2018 - Sep. 2020</div><br/><br/>

                    <strong class="work-title">Crossfit Trainer (substitute)</strong> <div class="place">High End Cross</div><br/> 
                    <div class="date">Summer of 2018</div><br/><br/>

                    <strong class="work-title">Sales Consultant</strong> <div class="place">Monday, JP/Politikens Hus, BestCall</div><br/> 
                    <div class="date">Oct. 2015 - Nov. 2017</div>

                </div>

                <div class="resume-section">
                    <h1>Competitions</h1><hr/>
                    <strong class="competition-title">ECB coding challenge on risk management</strong> <div class="place">European Central Bank</div><br/> 
                    <div class="date">25-27 Nov. 2019</div><br/><br/>

                    <strong class="competition-title">Georg Mohr</strong> <div class="place">Mathematical competition held in my High School</div><br/> 
                    <div class="date">Nov. 2017</div>
                </div>
                    
                <div class="resume-section">
                    <h1>Online courses</h1><hr/>
                    <strong class="education-title">UBCx's Software Development MicroMasters Program</strong> <div class="place">University of British Colombia, edX.org</div><br/> 
                    <div class="date">2018</div><br/><br/>

                    <strong class="education-title">CS50’s Introduction to Computer Science</strong> <div class="place">Harvard University, edX.org</div><br/> 
                    <div class="date">2016</div>

                </div>
            </div>
        </div>
        </div>
    );
  }
}